import { Typography } from '@euler/app/components/typography';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import Color from 'color';
import { forwardRef, memo, useImperativeHandle, useState } from 'react';
import { StyleProp, TextInput, View, ViewStyle } from 'react-native';

type Props = {
  style?: StyleProp<ViewStyle>;
};

export type ShareAlertContentRef = {
  getMobile(): string;
  setError(error?: string): void;
};

export const ShareAlertContent = memo(
  forwardRef<ShareAlertContentRef, Props>(({ style }, ref) => {
    const {
      alert: {
        textInputBgColor,
        textInputBorderColor,
        textInputTextColor,
        textInputPlaceholderTextColor,
        errorTextColor,
      },
    } = usePresentationTheme();

    const { rpx } = useResponsiveContext();

    const [mobile, setMobile] = useState('');
    const [error, setError] = useState<string>();

    useImperativeHandle(ref, () => ({
      getMobile() {
        return mobile;
      },
      setError: (value?: string) => {
        setError(value);
      },
    }));

    return (
      <View style={style}>
        {error != null && (
          <View
            css={`
              margin: 0 ${rpx(30)}px;
              margin-bottom: ${rpx(20)}px;
              border-width: 1px;
              border-color: ${errorTextColor};
              padding: ${rpx(20)}px;
              border-radius: ${rpx(12)}px;
              background-color: ${Color(errorTextColor).alpha(0.05).string()};
            `}
          >
            <Typography.Label regular size={rpx(18)} color={errorTextColor}>
              {error}
            </Typography.Label>
          </View>
        )}
        <TextInput
          value={mobile}
          onChangeText={setMobile}
          keyboardType="number-pad"
          placeholder="请输入手机号码发送报告详情"
          placeholderTextColor={textInputPlaceholderTextColor}
          css={`
            flex: 1;
            padding: 0 ${rpx(40)}px;
            height: ${rpx(108)}px;
            margin: 0 ${rpx(30)}px;
            font-family: ${FontFamily.NotoSans.Bold};
            font-weight: 700;
            font-size: ${rpx(28)}px;
            line-height: ${rpx(48)}px;
            color: ${textInputTextColor};
            text-align: center;
            background-color: ${textInputBgColor};
            border-width: 1px;
            border-color: ${textInputBorderColor};
            border-radius: ${rpx(12)}px;
          `}
        />
      </View>
    );
  }),
);
